var _rect, _rect2, _path, _rect3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "black",
    fillOpacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "black",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#FF0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 20.9091,
    height: 20.9091,
    fill: "black",
    fillOpacity: 0,
    transform: "translate(9.54541 9.54541)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.4636C25.259 10.4636 29.5363 14.7409 29.5363 20C29.5363 25.259 25.259 29.5363 20 29.5363C14.7409 29.5363 10.4636 25.259 10.4636 20C10.4636 14.7409 14.7409 10.4636 20 10.4636ZM20 9.54541C14.225 9.54541 9.54541 14.225 9.54541 20C9.54541 25.775 14.225 30.4545 20 30.4545C25.775 30.4545 30.4545 25.775 30.4545 20C30.4545 14.225 25.775 9.54541 20 9.54541Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 25.2275L25.2273 19.7729L16.3636 14.7729V25.2275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeMusic);
export default __webpack_public_path__ + "static/media/youtube-music.41263ce55abdb13494344345d47c12c2.svg";
export { ForwardRef as ReactComponent };